var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box-main" },
    [
      _c(
        "div",
        { staticClass: "main" },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "main-center" },
            [
              _c(
                "v-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "upgrade:version:add",
                      expression: "'upgrade:version:add'",
                    },
                  ],
                  staticClass: "v-icon-add",
                  attrs: { type: "primary", name: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showAddNewVersion()
                    },
                  },
                },
                [_vm._v("发布新版本")]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "upgrade:version:add",
                      expression: "'upgrade:version:add'",
                    },
                  ],
                  staticClass: "visontips",
                },
                [_vm._v("提示：发布新版本时，可选中某一版本作为上一个版本！")]
              ),
              _c("v-input", {
                staticClass: "inputsearch",
                attrs: {
                  placeholder: "请输入搜索内容",
                  "suffix-icon": "v-icon-search",
                },
                on: { change: _vm.searchdata },
                model: {
                  value: _vm.searchValue,
                  callback: function ($$v) {
                    _vm.searchValue = $$v
                  },
                  expression: "searchValue",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "vxe-table",
                {
                  ref: "xTable",
                  attrs: {
                    border: "",
                    "row-id": "id",
                    data: _vm.table,
                    align: "left",
                    "row-style": _vm.setRowClass,
                  },
                  on: {
                    "radio-change": _vm.checkMethod,
                    "cell-click": _vm.cellClickEvent,
                  },
                },
                [
                  _c("vxe-table-column", {
                    attrs: { type: "radio", width: "70", title: "请选择" },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "id",
                      "show-overflow": "",
                      "min-width": "40",
                      title: "ID",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "product_name",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "所属产品",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "product_key",
                      "show-overflow": "",
                      "min-width": "150",
                      title: "产品KEY",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "software_version",
                      "show-overflow": "",
                      "min-width": "250",
                      title: "软件版本",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "version_typeshow",
                      "show-overflow": "",
                      "min-width": "80",
                      title: "版本类型",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "created_at",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "发布日期",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "操作", "min-width": "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (slotProps) {
                          return [
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn1",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showEdit(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("编辑")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDown(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("下载")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn3",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDel(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn4",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDetails(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("详情")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn5",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showChain(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("版本链")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.total
            ? _c("v-pagination", {
                attrs: {
                  total: _vm.total,
                  name: "page-basic",
                  "is-show-total": "",
                  "is-change-size": "",
                  "is-input-page": "",
                  "current-page": this.currentPage,
                },
                on: {
                  "change-page": _vm.changePage,
                  "change-size": _vm.changeSize,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("Down", {
        ref: "Down",
        attrs: {
          showInputDialog: _vm.Downloading,
          UseId: _vm.showID,
          file_url: _vm.dowmfile_url,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Downloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Downloading = $event
          },
        },
      }),
      _c("Del", {
        ref: "Del",
        attrs: {
          showInputDialog: _vm.Delloading,
          UseId: _vm.showID,
          model: _vm.model,
          software_version: _vm.software_version,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Delloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Delloading = $event
          },
          getData: function ($event) {
            return _vm.getData()
          },
        },
      }),
      _vm.detailshow
        ? _c("Details", {
            ref: "Details",
            attrs: { showInputDialog: _vm.Detailsloading, row: _vm.rows },
            on: {
              getData: function ($event) {
                return _vm.getData()
              },
              change: _vm.showDetails,
            },
          })
        : _vm._e(),
      _vm.edshow
        ? _c("Edit", {
            ref: "Edit",
            attrs: { showInputDialog: _vm.Editloading, row: _vm.row },
            on: {
              getData: function ($event) {
                return _vm.getData()
              },
              change: _vm.showEdit,
            },
          })
        : _vm._e(),
      _c("AddNewVersion", {
        ref: "AddNewVersion",
        attrs: {
          showInputDialog: _vm.AddNewVersionloading,
          fatherVison: _vm.fatherVison,
          fatherProduct: _vm.fatherProduct,
          fatherSoftware: _vm.fatherSoftware,
          fatherVersion_type: _vm.fatherVersion_type,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.AddNewVersionloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.AddNewVersionloading = $event
          },
          getData: function ($event) {
            return _vm.getData()
          },
        },
      }),
      _c("VersionChain", {
        ref: "tan",
        attrs: {
          showAddDialog: _vm.tanchuloading,
          chainproductName: _vm.chainproductName,
          chainSoftware_version: _vm.chainSoftware_version,
          chainId: _vm.chainId,
        },
        on: {
          "update:showAddDialog": function ($event) {
            _vm.tanchuloading = $event
          },
          "update:show-add-dialog": function ($event) {
            _vm.tanchuloading = $event
          },
          change: _vm.showChain,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "main-title" }, [_vm._v("版本列表")]),
      _c("div", { staticClass: "main-title-tips" }, [
        _vm._v("可对软件升级版本信息进行查看和修改"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }